// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__XU8WQ","loader":"Loader_loader__DwtSp","spin":"Loader_spin__ddwRw","loader__text":"Loader_loader__text__OeAno"};